module.exports = __webpack_public_path__ + "static/media/newsletter.597aba8b.svg";